import { createSelector } from 'reselect';

const selectUser = (state) => state.user;

export const selectCurrentUser = createSelector(
  [selectUser],
  (user) => user.currentUser
);

export const selectError = createSelector([selectUser], (user) => user.error);

export const selectToken = createSelector([selectUser], (user) => user.token);

export const selectFetching = createSelector(
  [selectUser],
  (user) => user.fetching
);

export const selectIsChangePwd = createSelector(
  [selectUser],
  (user) => user.isChangePwd
);

export const selectFetchingAvatar = createSelector(
  [selectUser],
  (user) => user.fetchingAvatar
);

export const selectUpdatingProfile = createSelector(
  [selectUser],
  (user) => user.updatingProfile
);

export const selectCurrentUserRoles = createSelector(
  [selectCurrentUser],
  (currentUser) => currentUser?.roles || []
);

export const selectIsImpersonating = createSelector(
  [selectCurrentUser],
  (currentUser) => Boolean(currentUser?.isImpersonating)
);

export const selectHasRole = (role) =>
  createSelector([selectCurrentUserRoles], (roles) =>
    roles.includes(role)
  );
